import { render, staticRenderFns } from "./CoreDrag.vue?vue&type=template&id=39db15a7&"
import script from "./CoreDrag.vue?vue&type=script&lang=js&"
export * from "./CoreDrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports